var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceShuttleSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  .st0{fill:#000000;}  "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.203,331.781c-47.141-35.359-87.578-97.688-87.578-165.047c0-43.781,0-65.688,0-106.109 C316.625,27.141,289.484,0,256,0s-60.625,27.141-60.625,60.625c0,40.422,0,62.328,0,106.109 c0,67.359-40.438,129.688-87.578,165.047c-40,30-47.172,47.172-45.484,65.688c1.844,20.203,16.844,28.625,35.375,28.625h316.625 c18.531,0,33.547-8.422,35.375-28.625C451.375,378.953,444.203,361.781,404.203,331.781z M218.938,99.375 c0-20.469,16.594-37.063,37.063-37.063s37.063,16.594,37.063,37.063C293.063,119.828,218.938,119.828,218.938,99.375z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "242.531,512 232.422,441.266 181.891,441.266 171.797,512 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "340.203,512 330.109,441.266 279.578,441.266 269.469,512 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceShuttleSvgrepoCom);
export default __webpack_public_path__ + "static/media/space-shuttle-svgrepo-com.a9bd93f24d38de0d796f2be942c6500d.svg";
export { ForwardRef as ReactComponent };